import { Container, Card, Box, Stack, Button, Typography, Dialog, DialogContentText, DialogTitle, Divider, Paper, TextField, MenuItem, Grid } from '@material-ui/core';
import { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import apiTeam from '../../../../api/team';
import { objectID } from '../../../../utils/objectID';
import apiUser from '../../../../api/user';
import useAuth from '../../../../hooks/useAuth'
export default function OptionImport({ handleChangeOptionImport, chooseType, departmentSelected, setDepartmentSelected, setUserSelected, setIsSelectedType }) {
    const [departments, setDepartments] = useState([]);
    const [users, setUsers] = useState([]);
    const { user } = useAuth();
    const onChangeDepartment = (e) => {
        const load_user = async (param) => {
            const res_users = await apiUser.view(param);
            setUsers(res_users.data.data);
        }
        if (chooseType === "personal") {
            load_user({department_id: e.target.value});
            setDepartmentSelected(e.target.value)
        } else {
            load_user({department_id: e.target.value,is_leader:1});
            setDepartmentSelected(e.target.value)
        }
    }
    useEffect(() => {
        const loadDepartment = async () => {
            const res_teams = await apiTeam.listDepartment({})
            setDepartments(res_teams.data.data);
        }
        loadDepartment()
    }, []);
    const onChangeAssignedBy = async (e) => {
        setUserSelected(e.target.value)
        setIsSelectedType(true)
    }
    return (
        <Box sx={{ px: 1, py: 2 }}>
            <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                    <TextField
                        select
                        fullWidth
                        name="contact_for"
                        label="Phân bổ dữ liệu"
                        onChange={e => handleChangeOptionImport(e)}
                    >
                        <MenuItem value="me">{"Tôi"}</MenuItem>
                        <MenuItem value="department">{"Trưởng nhóm"}</MenuItem>
                        <MenuItem value="personal">{"Nhân viên"}</MenuItem>
                        {user.is_admin || user.is_leader ? <MenuItem value="custom">{"Tùy chỉnh"}</MenuItem>:null}
                    </TextField>
                </Grid>
                <Grid item xs={12} md={12}>
                    {chooseType === "department" &&
                        <Stack direction={"row"} spacing={2} >
                            <TextField
                                select
                                fullWidth
                                label={"Phòng ban phụ trách"}
                                placeholder={"Phòng ban"}
                                name="department_id"
                                onChange={e => onChangeDepartment(e)}
                            >
                                <MenuItem value="">Chọn phòng ban</MenuItem>
                                {departments.map((department, index) => {
                                    return (<MenuItem value={objectID(department._id)}>{department.name}</MenuItem>);
                                })}
                            </TextField>
                            <TextField
                                select
                                fullWidth
                                label="Người phụ trách"
                                placeholder={"Người phụ trách"}
                                name="assigned_by"
                                onChange={e => onChangeAssignedBy(e)}
                            >
                                <MenuItem value={user.id}>{"Tôi"}</MenuItem>
                                {users && users.map((item, index) => {
                                    return (<MenuItem key={index} value={objectID(item._id)}>{item.full_name}</MenuItem>);
                                })}
                            </TextField>
                        </Stack>
                    }
                </Grid>
                <Grid item xs={12} md={12}>
                    {chooseType === "personal" &&
                        <Stack direction={"row"} spacing={2} >
                            <TextField
                                select
                                fullWidth
                                label={"Phòng ban phụ trách"}
                                placeholder={"Phòng ban"}
                                name="department_id"
                                onChange={e => onChangeDepartment(e)}

                            >
                                <MenuItem value="">Chọn phòng ban</MenuItem>
                                {departments.map((department, index) => {
                                    return (<MenuItem value={objectID(department._id)}>{department.name}</MenuItem>);
                                })}
                            </TextField>
                            <TextField
                                select
                                fullWidth
                                label="Người phụ trách"
                                placeholder={"Người phụ trách"}
                                name="assigned_by"
                                onChange={e => onChangeAssignedBy(e)}
                            >
                                <MenuItem value={user.id}>{"Tôi"}</MenuItem>
                                {users && users.map((item, index) => {
                                    return (<MenuItem key={index} value={objectID(item._id)}>{item.full_name}</MenuItem>);
                                })}
                            </TextField>
                        </Stack>
                    }
                </Grid>
            </Grid>
        </Box>
    )
}